/* eslint-disable jsx-a11y/label-has-associated-control,react/no-unused-prop-types */
import { AttributeChoiceTypeEnum } from '@sdk/gqlTypes/generatedTypes';

import { AttributeFieldDropdown } from './AttributeFieldDropdown';
import { AttributeFieldSwatch } from './AttributeFieldSwatch';
import { AttributeFieldSlider } from './AttributeFieldSlider';
import { AttributeFieldPill } from './AttributeFieldPill';
import { AttributeFieldTrack } from './AttributeFieldTrack';

import { IAttributeFieldProps } from './types';

const AttributeFieldTypesDictionary = {
  [AttributeChoiceTypeEnum.DROPDOWN]: AttributeFieldDropdown,
  [AttributeChoiceTypeEnum.SWATCH]: AttributeFieldSwatch,
  [AttributeChoiceTypeEnum.SLIDER]: AttributeFieldSlider,
  [AttributeChoiceTypeEnum.TOGGLE]: AttributeFieldPill,
  [AttributeChoiceTypeEnum.MULTISELECT]: AttributeFieldTrack,
};

export const getAttributeChoiceTypeFieldComponent = (
  choiceType: AttributeChoiceTypeEnum
): React.FC<IAttributeFieldProps> => {
  const ChoiceTypeFieldComponent = AttributeFieldTypesDictionary[choiceType];
  if (!ChoiceTypeFieldComponent) {
    console.error(`ChoiceTypeFieldComponent for type ${choiceType} not found`);
    return AttributeFieldDropdown;
  }
  return ChoiceTypeFieldComponent;
};
